const Vue = require('vue')
import apihelper from './apihelper'

export default {
    getview(p) {
        return apihelper.get("/WorkGroup/GetView", p);
    }
}